// import { FC, useContext, useState, MouseEvent, useRef, useEffect } from "react";
// import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";

// import DropdownPossibleNextStep from "../dropdownPossibleNextStep";

// import { AuthContext } from "src/context/authContext";
// import useFetch from "src/hooks/useFetch";

// import { LogoBrandWhite } from "src/assets";
// import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
// import { HeaderElementType } from "src/types";
// import { APIEndpoints } from "src/types/apiTypes";
// import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";
// import useLogout from "src/hooks/useLogout";
// import { ACCESS_TO_LOCAL_COVERAGE_REPORT, getReportsByRole, USER_TYPES } from "../../constants";
// import { resourceAnalyticsAPIResponse } from "./types";



// const AuthHeader: FC = (): JSX.Element => {
//   const navigate = useNavigate();
//   const location = useLocation()
//   const { userData, isManufacturer, isUserAuthorized, report_listing } = useContext(AuthContext);
//   const { logoutUser } = useLogout()
//   const { pathname } = useLocation()
//   const dropdowns = useRef<HTMLUListElement>(null)
//   const [openSubmenus, setOpenSubmenus] = useState<number[]>([]);

//   const autoCollapseSubmenu = (event: MouseEvent<HTMLAnchorElement>, submenuIndex: number) => {
//     // Check if clicked element is the dropdown toggle
//     if ((event.target as HTMLAnchorElement).matches('a.dropdown-item.dropdown-toggle')) {
//       event.stopPropagation(); // Prevent parent dropdown from collapsing
//       setOpenSubmenus((prevState) => {
//         const isAlreadyOpen = prevState.includes(submenuIndex);

//         if (isAlreadyOpen) {
//           // Close the submenu
//           return prevState.filter((index) => index !== submenuIndex);
//         } else {
//           // Close all other submenus and open the clicked one
//           return [submenuIndex];
//         }
//       });
//     }
//   };

//   const { data: resourseAnalyticsResponse, mutate: resourseAnalyticsMutate } =
//     useFetch<resourceAnalyticsAPIResponse>(APIEndpoints.RESOURCE_ANALYTICS, {}, { userId: userData?.id });

//   useEffect(() => {
//     if (resourseAnalyticsResponse && resourseAnalyticsResponse.code === 200) {

//       // updateUserData({ ...userData, ...resourseAnalyticsResponse.status.data.user });
//       //setTimeout(() => navigate(0), 300)
//       // console.log("Api Response Successful")

//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [resourseAnalyticsResponse]);

//   const clickOnResources = (product: string, resources: string) => {
//     //console.log("Click On Resources.......",product,"     dfgsdfgsdgsdfgsdfgf",resources);
//     const params = {
//       product: product === "iovera Resources" ? 'iovera' : 'zilretta',
//       resource: resources,
//       clicked_at: new Date(),
//       clicked_by: userData?.name,
//       clicked_by_id: userData?.id
//     }
//     resourseAnalyticsMutate({}, {}, params)
//   }

//   const { data: retreatmentRequestCount } =
//     useFetch<{ retreatment_count: number; }>(APIEndpoints.GET_RETREATMENT_REQUESTS_COUNT, {}, {}, !isManufacturer);

//   const closeMobileMenu = () => {
//     const navbarCollapse = document.getElementById('authHeader');
//     if (navbarCollapse && navbarCollapse.classList.contains('show')) {
//       navbarCollapse.classList.remove('show');
//     }
//   };



//   return (
//     <nav className="navbar navbar-expand-lg p-3 pt-2 pb-2" style={{ backgroundColor: "#464ba3" }}>
//       <Link className="navbar-brand p-0" to={isUserAuthorized ?
//         (userData?.is_password_changed ?
//           (isManufacturer ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : (userData.baa_viewed ? `/cases` : "/pages/baa")) :
//           '/users/createuser'
//         ) :
//         `/users/sign_in`
//       }
//       >
//         <img className="img-fluid after-login-logo" src={LogoBrandWhite} alt="Site logo" />
//       </Link>
//       <button className="navbar-toggler btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
//         <span className="navbar-toggler-icon"></span>
//       </button>

//       <div className="collapse navbar-collapse" id="authHeader">
//         <ul className="navbar-nav me-auto first-nav">
//           {userData?.is_password_changed ? (
//             <>
//               {isManufacturer === true ?
//                 AuthenticatedManufactureHeader.map((headerLink, index) => (
//                   <li
//                     className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
//                     key={index}
//                   >
//                     {headerLink.actionType === HeaderElementType.ROUTE ? (
//                      // ((headerLink.title === "Action Dashboard" && userData.email === "devh@elusahealth.com") ? 
//                       <NavLink
//                         className={({ isActive }) => {
//                           return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
//                         }}
//                         aria-current="page"
//                         to={headerLink.redirectLink === "/statistics" ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : headerLink.redirectLink}
//                         end
//                         onClick={closeMobileMenu}
//                       >
//                         {headerLink.title}
//                       </NavLink> 
//                       // :
//                       // (headerLink.title !== "Action Dashboard" && 
//                       // <NavLink
//                       //   className={({ isActive }) => {
//                       //     return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
//                       //   }}
//                       //   aria-current="page"
//                       //   to={headerLink.redirectLink === "/statistics" ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : headerLink.redirectLink}
//                       //   end
//                       //   onClick={closeMobileMenu}
//                       // >
//                       //   {headerLink.title}
//                       // </NavLink>)
//                        )
//                     //)
//                      : null}
//                     {headerLink.actionType === HeaderElementType.BUTTON ? (
//                       <button
//                         className="btn btn-primary rounded-pill"
//                         onClick={() => {
//                           closeMobileMenu();
//                           navigate(headerLink.redirectLink);
//                         }}
//                       >
//                         {headerLink.title}
//                       </button>
//                     ) : null}
//                     {headerLink.actionType === HeaderElementType.LINK ? (
//                       <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
//                         {headerLink.title}
//                       </a>
//                     ) : null}

//                     {headerLink.actionType === HeaderElementType.DRPODOWN ?
//                       (headerLink.title === "Reports") ?
//                         (
//                           <>
//                             <button
//                               className={`nav-link dropdown-toggle ${pathname.includes("report") && headerLink.title === "Reports" ? "custom-active-link show" : ""}`}
//                               data-bs-toggle="dropdown"
//                               aria-expanded="false"
//                               onClick={(e) => {
//                                 if (e.currentTarget.classList.contains("show")) {
//                                   e.currentTarget.classList.add("custom-active-link")
//                                 } else {
//                                   if (!(pathname.includes("report") && headerLink.title === "Reports"))
//                                     e.currentTarget.classList.remove("custom-active-link")
//                                 }
//                               }}
//                               onFocus={(e) => e.target.classList.add("custom-active-link")}
//                               onBlur={(e) => {
//                                 if (!(pathname.includes("report") && headerLink.title === "Reports")) {
//                                   e.target.classList.remove("custom-active-link")
//                                 }
//                               }}
//                             >
//                               {headerLink.title}
//                             </button>
//                             <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-center shadow">

//                               {/* getReportsByRole(userData.ref_type).map() */}
//                               {
//                                 //headerLink.dropdown && headerLink.dropdown
//                                 (userData && report_listing) && getReportsByRole(report_listing).map((header: any, index: number) => (
//                                   <li key={index}>
//                                     {headerLink.title === "Reports" ? (
//                                       header.redirectLink && header.redirectLink !== "/" ? (
//                                         <>
//                                           {header.title === "Local Coverage Analytics" ?
//                                             (ACCESS_TO_LOCAL_COVERAGE_REPORT.includes(userData?.email) ? (
//                                               <Link
//                                                 to={header.redirectLink}
//                                                 className="dropdown-item"
//                                                 onClick={() => {
//                                                   if (dropdowns && dropdowns.current) {
//                                                     dropdowns.current.classList.remove("show")
//                                                   }
//                                                 }}
//                                               >
//                                                 {header.title}
//                                               </Link>
//                                             ) : null) :
//                                             <Link
//                                               to={header.redirectLink}
//                                               className="dropdown-item"
//                                               onClick={() => {
//                                                 if (dropdowns && dropdowns.current) {
//                                                   dropdowns.current.classList.remove("show")
//                                                 }
//                                               }}
//                                             >
//                                               {header.title}
//                                             </Link>
//                                           }
//                                         </>
//                                       ) : (
//                                         <span className="dropdown-item">
//                                           {header.title}
//                                         </span>
//                                       )
//                                     ) : (
//                                       header.redirectLink && header.redirectLink !== "/" ? (
//                                         <a
//                                           href={header.redirectLink}
//                                           target="_blank"
//                                           rel="noreferrer"
//                                           className="dropdown-item"
//                                         >
//                                           {header.title}
//                                         </a>
//                                       ) : (
//                                         <span className="dropdown-item">
//                                           {header.title}
//                                         </span>
//                                       )
//                                     )}
//                                   </li>
//                                 ))}


//                             </ul>
//                           </>
//                         ) :
//                         ((headerLink.title !== "Reports" && <>
//                           <a className="nav-link dropdown-toggle" href="."
//                             data-bs-toggle="dropdown" aria-expanded="false"
//                           >
//                             {headerLink.title}
//                           </a>
//                           <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-menu-start">
//                             {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
//                               return header.dropdown && header.dropdown.length > 0 ?
//                                 (
//                                   <>
//                                     <li className="submenu submenu-md dropend"
//                                       key={index}>
//                                       <a className="dropdown-item dropdown-toggle"
//                                         role="button"
//                                         data-bs-toggle="dropdown" aria-expanded="false"
//                                         onClick={(event) => autoCollapseSubmenu(event, index)}
//                                         href="."
//                                       >
//                                         {header.title}
//                                       </a>
//                                       <ul className={`shadow dropdown-menu py-2${openSubmenus.includes(index) ? ' show' : ' xs-d-none'}`}>
//                                         {header.dropdown.map((dropdown, index) => (
//                                           <li className="px-0" key={index}>
//                                             <a
//                                               className="dropdown-item"
//                                               href={dropdown.redirectLink}
//                                               target="_blank" rel="noreferrer"
//                                               onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}
//                                             >
//                                               {dropdown.title}
//                                             </a>
//                                           </li>
//                                         ))}
//                                       </ul>
//                                     </li></>
//                                 ) : (
//                                   <li key={index}>
//                                     <a className="dropdown-item"
//                                       href={header.redirectLink} target="_blank"
//                                       rel="noreferrer">
//                                       {header.title}
//                                     </a>
//                                   </li>
//                                 )
//                             })}
//                           </ul>
//                         </>)
//                         )
//                         :null}

//                   </li>
//                 ))
//                 :
//                 <>
//                   {userData.baa_viewed && AuthenticatedHCPHeader.map((headerLink, index) => (
//                     <li
//                       className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
//                       key={index}
//                     >
//                       {headerLink.actionType === HeaderElementType.ROUTE ? (
//                         <NavLink
//                           className={({ isActive }) => {
//                             return ["nav-link text-nowrap", isActive ? "custom-active-link" : ""].join(" ")
//                           }}
//                           reloadDocument={
//                             headerLink.redirectLink === "/cases/new" &&
//                             (location.pathname.includes("clone") || location.pathname.includes("new"))
//                           }
//                           aria-current="page"
//                           to={headerLink.redirectLink}
//                           end
//                           onClick={closeMobileMenu}
//                         >
//                           <span>{headerLink.title}</span>{' '}
//                           {headerLink.redirectLink === "/retreatments" ?
//                             retreatmentRequestCount ?
//                               (
//                                 <span className="bg-primary text-white rounded-1 p-1" style={{ fontSize: 11 }}>
//                                   {retreatmentRequestCount.retreatment_count}
//                                 </span>
//                               ) : (
//                                 <span className="placeholder-glow">
//                                   <span className="placeholder bg-primary" style={{ minWidth: 15 }}></span>
//                                 </span>
//                               )
//                             : null
//                           }
//                           {headerLink.redirectLink === "/cases/new" && userData && userData.draft_count > 0 ?
//                             <span
//                               className="badge rounded-circle text-bg-danger"
//                               style={{
//                                 position: "relative",
//                                 fontSize: 10,
//                                 top: -2,
//                               }}
//                             >
//                               {userData?.draft_count}
//                             </span>
//                             : null
//                           }
//                         </NavLink>
//                       ) : null}
//                       {headerLink.actionType === HeaderElementType.BUTTON ? (
//                         <button
//                           style={{ background: 'background-color-5' }}
//                           className="btn btn-primary rounded-pill"
//                           onClick={() => {
//                             closeMobileMenu();
//                             navigate(headerLink.redirectLink);
//                           }}
//                         >
//                           {headerLink.title}
//                         </button>
//                       ) : null}
//                       {headerLink.actionType === HeaderElementType.LINK ? (
//                         <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
//                           {headerLink.title}
//                         </a>
//                       ) : null}
//                       {headerLink.actionType === HeaderElementType.DRPODOWN ? (
//                         <>
//                           <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
//                             aria-expanded="false"
//                           >
//                             {headerLink.title}
//                           </a>
//                           <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
//                             {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
//                               <li key={index}>
//                                 <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
//                                   {header.title}
//                                 </a>
//                               </li>
//                             ))}
//                           </ul>
//                         </>
//                       ) : null}
//                     </li>
//                   ))}
//                 </>
//               }
//             </>
//           ) : null}
//         </ul>

//         <div className="text-start text-lg-end">
//           <ul className="navbar-nav justify-content-end">
//             {userData?.is_password_changed ? (
//               isManufacturer ?
//                 <>
//                   <DropdownStatusColorMeaning />
//                   <li className="nav-item dropdown">
//                     <a
//                       className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
//                       aria-expanded="false" role="button"
//                     >
//                       {userData?.name}
//                     </a>
//                     <ul className="dropdown-menu dropdown-menu-end">
//                       <li>
//                         <Link className="dropdown-item text-black" to='/users/updateuser' onClick={closeMobileMenu}>
//                           Account Settings
//                         </Link>
//                       </li>
//                       <li>
//                         <hr className="dropdown-divider" />
//                       </li>
//                       <li>
//                         <button className="dropdown-item text-black"
//                           onClick={() => logoutUser()}
//                         >Logout</button>
//                       </li>
//                     </ul>
//                   </li>
//                 </>
//                 :
//                 <>
//                   {userData?.baa_viewed ? (
//                     <>
//                       <DropdownStatusColorMeaning />
//                       <DropdownPossibleNextStep />
//                       <li className="nav-item dropdown">
//                         <a
//                           className="nav-link dropdown-toggle" href="."
//                           data-bs-toggle="dropdown"
//                           aria-expanded="false"
//                           role="button"
//                         >
//                           {userData?.name}
//                         </a>
//                         <ul className="dropdown-menu dropdown-menu-end">
//                           <li><Link className="dropdown-item text-black" to="/users/updateuser" onClick={closeMobileMenu}>
//                             Account Settings</Link>
//                           </li>
//                           <li><Link className="dropdown-item text-black" to="/users/new" onClick={closeMobileMenu}>Add User</Link>
//                           </li>
//                           <li><Link className="dropdown-item text-black" to="/doctors/new" onClick={closeMobileMenu}>
//                             Add Prescriber
//                           </Link></li>
//                           {USER_TYPES.HCP.includes(userData.ref_type) && userData.ref_type !== "GlobalDoctor" && (
//                             <li>
//                               <Link className="dropdown-item text-black" to="/pages/signaturemanagement" onClick={closeMobileMenu}>
//                                 Add Signature
//                               </Link>
//                             </li>
//                           )}


//                           <li><Link className="dropdown-item text-black" to="/pages/baa" onClick={closeMobileMenu}>BAA</Link></li>
//                           <li>
//                             <hr className="dropdown-divider" />
//                           </li>
//                           <li>
//                             <button className="dropdown-item text-black"
//                               onClick={() => {
//                                 closeMobileMenu();
//                                 logoutUser();
//                               }}>
//                               Logout
//                             </button>
//                           </li>
//                         </ul>
//                       </li>
//                     </>
//                   ) : (
//                     <li className="nav-item dropdown">
//                       <a
//                         className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
//                         aria-expanded="false" role="button"
//                       >
//                         {userData?.name}
//                       </a>
//                       <ul className="dropdown-menu dropdown-menu-end">
//                         <li><button className="dropdown-item text-black"
//                           onClick={() => {
//                             closeMobileMenu();
//                             logoutUser();
//                           }}>
//                           Logout</button></li>
//                       </ul>
//                     </li>
//                   )}
//                 </>
//             ) : (
//               <li className="nav-item dropdown">
//                 <button
//                   className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   {userData?.name}
//                 </button>
//                 <ul className="dropdown-menu dropdown-menu-end">
//                   <li><a className="dropdown-item text-black" href="."
//                     onClick={() => {
//                       closeMobileMenu();
//                       logoutUser();
//                     }}>Logout</a></li>
//                 </ul>
//               </li>
//             )}
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default AuthHeader;

import { FC, useContext, useState, MouseEvent, useRef, useEffect } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";

import DropdownPossibleNextStep from "../dropdownPossibleNextStep";

import { AuthContext } from "src/context/authContext";
import useFetch from "src/hooks/useFetch";

import { LogoBrandWhite } from "src/assets";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";
import useLogout from "src/hooks/useLogout";
import { ACCESS_TO_LOCAL_COVERAGE_REPORT, getReportsByRole, USER_TYPES } from "../../constants";
import { resourceAnalyticsAPIResponse } from "./types";



const AuthHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation()
  const { userData, isManufacturer, isUserAuthorized, report_listing } = useContext(AuthContext);
  const { logoutUser } = useLogout()
  const { pathname } = useLocation()
  const dropdowns = useRef<HTMLUListElement>(null)
  const [openSubmenus, setOpenSubmenus] = useState<number[]>([]);

  const autoCollapseSubmenu = (event: MouseEvent<HTMLAnchorElement>, submenuIndex: number) => {
    // Check if clicked element is the dropdown toggle
    if ((event.target as HTMLAnchorElement).matches('a.dropdown-item.dropdown-toggle')) {
      event.stopPropagation(); // Prevent parent dropdown from collapsing
      setOpenSubmenus((prevState) => {
        const isAlreadyOpen = prevState.includes(submenuIndex);

        if (isAlreadyOpen) {
          // Close the submenu
          return prevState.filter((index) => index !== submenuIndex);
        } else {
          // Close all other submenus and open the clicked one
          return [submenuIndex];
        }
      });
    }
  };

  const { data: resourseAnalyticsResponse, mutate: resourseAnalyticsMutate } =
    useFetch<resourceAnalyticsAPIResponse>(APIEndpoints.RESOURCE_ANALYTICS, {}, { userId: userData?.id });

  useEffect(() => {
    if (resourseAnalyticsResponse && resourseAnalyticsResponse.code === 200) {

      // updateUserData({ ...userData, ...resourseAnalyticsResponse.status.data.user });
      //setTimeout(() => navigate(0), 300)
      // console.log("Api Response Successful")

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourseAnalyticsResponse]);

  const clickOnResources = (product: string, resources: string) => {
    //console.log("Click On Resources.......",product,"     dfgsdfgsdgsdfgsdfgf",resources);
    const params = {
      product: product === "iovera Resources" ? 'iovera' : 'zilretta',
      resource: resources,
      clicked_at: new Date(),
      clicked_by: userData?.name,
      clicked_by_id: userData?.id
    }
    resourseAnalyticsMutate({}, {}, params)
  }

  const { data: retreatmentRequestCount } =
    useFetch<{ retreatment_count: number; }>(APIEndpoints.GET_RETREATMENT_REQUESTS_COUNT, {}, {}, !isManufacturer);

  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('authHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };



  return (
    <nav className="navbar navbar-expand-lg p-3 pt-2 pb-2" style={{ backgroundColor: "#464ba3" }}>
      <Link className="navbar-brand p-0" to={isUserAuthorized ?
        (userData?.is_password_changed ?
          (isManufacturer ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : (userData.baa_viewed ? `/cases` : "/pages/baa")) :
          '/users/createuser'
        ) :
        `/users/sign_in`
      }
      >
        <img className="img-fluid after-login-logo" src={LogoBrandWhite} alt="Site logo" />
      </Link>
      <button className="navbar-toggler btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="authHeader">
        <ul className="navbar-nav me-auto first-nav">
          {userData?.is_password_changed ? (
            <>
              {isManufacturer === true ?
                AuthenticatedManufactureHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                      ((headerLink.title === "Action Dashboard" && process.env.REACT_APP_ENV !== 'production') ? 
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={headerLink.redirectLink === "/statistics" ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : headerLink.redirectLink}
                        end
                        onClick={closeMobileMenu}
                      >
                        {headerLink.title}
                      </NavLink> 
                       :
                      (headerLink.title !== "Action Dashboard" && 
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={headerLink.redirectLink === "/statistics" ? userData.ref_type === "Manufacturer" ? `/statistics` : `/statistics/${userData.id}` : headerLink.redirectLink}
                        end
                        onClick={closeMobileMenu}
                      >
                        {headerLink.title}
                      </NavLink>)
                       )
                    )
                     : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button
                        className="btn btn-primary rounded-pill"
                        onClick={() => {
                          closeMobileMenu();
                          navigate(headerLink.redirectLink);
                        }}
                      >
                        {headerLink.title}
                      </button>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                        {headerLink.title}
                      </a>
                    ) : null}

                    {headerLink.actionType === HeaderElementType.DRPODOWN ?
                      (headerLink.title === "Reports" && process.env.REACT_APP_ENV !== 'production') ?
                        (
                          <>
                            <button
                              className={`nav-link dropdown-toggle ${pathname.includes("report") && headerLink.title === "Reports" ? "custom-active-link show" : ""}`}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => {
                                if (e.currentTarget.classList.contains("show")) {
                                  e.currentTarget.classList.add("custom-active-link")
                                } else {
                                  if (!(pathname.includes("report") && headerLink.title === "Reports"))
                                    e.currentTarget.classList.remove("custom-active-link")
                                }
                              }}
                              onFocus={(e) => e.target.classList.add("custom-active-link")}
                              onBlur={(e) => {
                                if (!(pathname.includes("report") && headerLink.title === "Reports")) {
                                  e.target.classList.remove("custom-active-link")
                                }
                              }}
                            >
                              {headerLink.title}
                            </button>
                            <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-center shadow">

                              {/* getReportsByRole(userData.ref_type).map() */}
                              {
                                //headerLink.dropdown && headerLink.dropdown
                                (userData && report_listing) && getReportsByRole(report_listing).map((header: any, index: number) => (
                                  <li key={index}>
                                    {headerLink.title === "Reports" ? (
                                      header.redirectLink && header.redirectLink !== "/" ? (
                                        <>
                                          {header.title === "Local Coverage Analytics" ?
                                            (ACCESS_TO_LOCAL_COVERAGE_REPORT.includes(userData?.email) ? (
                                              <Link
                                                to={header.redirectLink}
                                                className="dropdown-item"
                                                onClick={() => {
                                                  if (dropdowns && dropdowns.current) {
                                                    dropdowns.current.classList.remove("show")
                                                  }
                                                }}
                                              >
                                                {header.title}
                                              </Link>
                                            ) : null) :
                                            <Link
                                              to={header.redirectLink}
                                              className="dropdown-item"
                                              onClick={() => {
                                                if (dropdowns && dropdowns.current) {
                                                  dropdowns.current.classList.remove("show")
                                                }
                                              }}
                                            >
                                              {header.title}
                                            </Link>
                                          }
                                        </>
                                      ) : (
                                        <span className="dropdown-item">
                                          {header.title}
                                        </span>
                                      )
                                    ) : (
                                      header.redirectLink && header.redirectLink !== "/" ? (
                                        <a
                                          href={header.redirectLink}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="dropdown-item"
                                        >
                                          {header.title}
                                        </a>
                                      ) : (
                                        <span className="dropdown-item">
                                          {header.title}
                                        </span>
                                      )
                                    )}
                                  </li>
                                ))}


                            </ul>
                          </>
                        ) :
                        ((headerLink.title !== "Reports" && <>
                          <a className="nav-link dropdown-toggle" href="."
                            data-bs-toggle="dropdown" aria-expanded="false"
                          >
                            {headerLink.title}
                          </a>
                          <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-menu-start">
                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                              return header.dropdown && header.dropdown.length > 0 ?
                                (
                                  <>
                                    <li className="submenu submenu-md dropend"
                                      key={index}>
                                      <a className="dropdown-item dropdown-toggle"
                                        role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        onClick={(event) => autoCollapseSubmenu(event, index)}
                                        href="."
                                      >
                                        {header.title}
                                      </a>
                                      <ul className={`shadow dropdown-menu py-2${openSubmenus.includes(index) ? ' show' : ' xs-d-none'}`}>
                                        {header.dropdown.map((dropdown, index) => (
                                          <li className="px-0" key={index}>
                                            <a
                                              className="dropdown-item"
                                              href={dropdown.redirectLink}
                                              target="_blank" rel="noreferrer"
                                              onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}
                                            >
                                              {dropdown.title}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    </li></>
                                ) : (
                                  <li key={index}>
                                    <a className="dropdown-item"
                                      href={header.redirectLink} target="_blank"
                                      rel="noreferrer">
                                      {header.title}
                                    </a>
                                  </li>
                                )
                            })}
                          </ul>
                        </>)
                        )
                        :null}

                  </li>
                ))
                :
                <>
                  {userData.baa_viewed && AuthenticatedHCPHeader.map((headerLink, index) => (
                    <li
                      className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                      key={index}
                    >
                      {headerLink.actionType === HeaderElementType.ROUTE ? (
                        <NavLink
                          className={({ isActive }) => {
                            return ["nav-link text-nowrap", isActive ? "custom-active-link" : ""].join(" ")
                          }}
                          reloadDocument={
                            headerLink.redirectLink === "/cases/new" &&
                            (location.pathname.includes("clone") || location.pathname.includes("new"))
                          }
                          aria-current="page"
                          to={headerLink.redirectLink}
                          end
                          onClick={closeMobileMenu}
                        >
                          <span>{headerLink.title}</span>{' '}
                          {headerLink.redirectLink === "/retreatments" ?
                            retreatmentRequestCount ?
                              (
                                <span className="bg-primary text-white rounded-1 p-1" style={{ fontSize: 11 }}>
                                  {retreatmentRequestCount.retreatment_count}
                                </span>
                              ) : (
                                <span className="placeholder-glow">
                                  <span className="placeholder bg-primary" style={{ minWidth: 15 }}></span>
                                </span>
                              )
                            : null
                          }
                          {headerLink.redirectLink === "/cases/new" && userData && userData.draft_count > 0 ?
                            <span
                              className="badge rounded-circle text-bg-danger"
                              style={{
                                position: "relative",
                                fontSize: 10,
                                top: -2,
                              }}
                            >
                              {userData?.draft_count}
                            </span>
                            : null
                          }
                        </NavLink>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.BUTTON ? (
                        <button
                          style={{ background: 'background-color-5' }}
                          className="btn btn-primary rounded-pill"
                          onClick={() => {
                            closeMobileMenu();
                            navigate(headerLink.redirectLink);
                          }}
                        >
                          {headerLink.title}
                        </button>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.LINK ? (
                        <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                          {headerLink.title}
                        </a>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                        <>
                          <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {headerLink.title}
                          </a>
                          <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                              <li key={index}>
                                <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
                                  {header.title}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : null}
                    </li>
                  ))}
                </>
              }
            </>
          ) : null}
        </ul>

        <div className="text-start text-lg-end">
          <ul className="navbar-nav justify-content-end">
            {userData?.is_password_changed ? (
              isManufacturer ?
                <>
                  <DropdownStatusColorMeaning />
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false" role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link className="dropdown-item text-black" to='/users/updateuser' onClick={closeMobileMenu}>
                          Account Settings
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <button className="dropdown-item text-black"
                          onClick={() => logoutUser()}
                        >Logout</button>
                      </li>
                    </ul>
                  </li>
                </>
                :
                <>
                  {userData?.baa_viewed ? (
                    <>
                      <DropdownStatusColorMeaning />
                      <DropdownPossibleNextStep />
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle" href="."
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          role="button"
                        >
                          {userData?.name}
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li><Link className="dropdown-item text-black" to="/users/updateuser" onClick={closeMobileMenu}>
                            Account Settings</Link>
                          </li>
                          <li><Link className="dropdown-item text-black" to="/users/new" onClick={closeMobileMenu}>Add User</Link>
                          </li>
                          <li><Link className="dropdown-item text-black" to="/doctors/new" onClick={closeMobileMenu}>
                            Add Prescriber
                          </Link></li>
                          {/* {USER_TYPES.HCP.includes(userData.ref_type) && userData.ref_type !== "GlobalDoctor" && (
                            <li>
                              <Link className="dropdown-item text-black" to="/pages/signaturemanagement" onClick={closeMobileMenu}>
                                Add Signature
                              </Link>
                            </li>
                          )} */}


                          <li><Link className="dropdown-item text-black" to="/pages/baa" onClick={closeMobileMenu}>BAA</Link></li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <button className="dropdown-item text-black"
                              onClick={() => {
                                closeMobileMenu();
                                logoutUser();
                              }}>
                              Logout
                            </button>
                          </li>
                        </ul>
                      </li>
                    </>
                  ) : (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                        aria-expanded="false" role="button"
                      >
                        {userData?.name}
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li><button className="dropdown-item text-black"
                          onClick={() => {
                            closeMobileMenu();
                            logoutUser();
                          }}>
                          Logout</button></li>
                      </ul>
                    </li>
                  )}
                </>
            ) : (
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {userData?.name}
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><a className="dropdown-item text-black" href="."
                    onClick={() => {
                      closeMobileMenu();
                      logoutUser();
                    }}>Logout</a></li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
